import { post, get } from 'Api';
import store from 'Redux/store';

export async function getUserRecommendations(recentlyViewedSlugs) {
  return post(store.dispatch, '/user/recommendations', recentlyViewedSlugs)
    .then(({ data }) => data.hits)
    .catch(() => {});
}

export async function getLongTailRecommendations() {
  return get(store.dispatch, '/user/long-tail-recommendations')
    .then(({ data }) => data)
    .catch(() => {});
}

export async function logViewed(slugs) {
  return post(store.dispatch, '/user/recommendations/viewed', slugs)
    .catch(() => {});
}
